import {Component, OnInit} from '@angular/core';
import {LoanApplicationService} from '../loan-application.service';

@Component({
  selector: 'bb-thank-you',
  templateUrl: './thank-you.component.html',
  styleUrls: ['./thank-you.component.scss'],
})
export class ThankYouComponent implements OnInit {

  constructor(private loan: LoanApplicationService) {
  }

  ngOnInit() {
    this.loan.resetForm();
  }
}
